import type { FluxErrorEntityErrorCodes } from '../types.js';

export const TeamErrorCodes = {
  TeamNotFound: {
    code: 'team/not-found',
    message: 'Time não encontrado.',
    explanation: 'O time que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
  TeamDeleteHasAssignedCards: {
    code: 'team/delete-has-assigned-cards',
    message: 'Time não pode ser excluído, pois possui cards atribuídos.',
    explanation:
      'O time que você está tentando excluir possui cards atribuídos, remova o time dos cards antes de excluí-lo.',
    localizations: {},
  },
} satisfies FluxErrorEntityErrorCodes<'team'>;

export const TeamsMembersErrorCodes = {
  TeamMemberNotFound: {
    code: 'team-member/not-found',
    message: 'Membro do time não encontrado.',
    explanation: 'O membro do time que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
  TeamMemberAlreadyExists: {
    code: 'team-member/already-exists',
    message: 'Membro do time já existe.',
    explanation: 'O membro do time que você está tentando adicionar já existe.',
    localizations: {},
  },
  TeamMemberRemoveLastMember: {
    code: 'team-member/remove-last-member',
    message: 'Não é possível remover o último membro do time.',
    explanation:
      'O time deve ter pelo menos um membro, por esse motivo não é possível remover o último membro do time. Caso deseje, exclua o time.',
    localizations: {},
  },
} satisfies FluxErrorEntityErrorCodes<'team-member'>;
